import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-12 bg-slate-950 border-t border-slate-900" data-id="element-43">
        <div className="max-w-4xl mx-auto px-6" data-id="element-44">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-45">
            <p className="text-slate-600 text-sm" data-id="element-46">
              © {new Date().getFullYear()} Club de las 3AM. Todos los derechos
              reservados.
            </p>

            <div className="flex items-center gap-6" data-id="element-47">
              <button onClick={() => setActiveModal('privacy')} className="text-slate-500 hover:text-amber-400 text-sm transition-colors" data-id="element-48">
                Política de Privacidad
              </button>
              <button onClick={() => setActiveModal('terms')} className="text-slate-500 hover:text-amber-400 text-sm transition-colors" data-id="element-49">
                Términos de Servicio
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-50">
        <div className="space-y-6" data-id="element-51">
          <section data-id="element-52">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-53">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-54">
              Recopilamos información que nos proporcionas directamente cuando
              realizas una compra, incluyendo tu nombre y dirección de correo
              electrónico. Esta información es necesaria para procesar tu pedido
              y entregarte el producto digital.
            </p>
          </section>

          <section data-id="element-55">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-56">
              2. Uso de la Información
            </h3>
            <p data-id="element-57">Utilizamos la información recopilada para:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-slate-400" data-id="element-58">
              <li data-id="element-59">Procesar y completar tu compra</li>
              <li data-id="element-60">Enviarte el producto digital adquirido</li>
              <li data-id="element-61">Comunicarnos contigo sobre tu pedido</li>
              <li data-id="element-62">Mejorar nuestros productos y servicios</li>
            </ul>
          </section>

          <section data-id="element-63">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-64">
              3. Protección de Datos
            </h3>
            <p data-id="element-65">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              alteración, divulgación o destrucción. Tus datos de pago son
              procesados de forma segura a través de proveedores de pago
              certificados.
            </p>
          </section>

          <section data-id="element-66">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-67">
              4. Compartir Información
            </h3>
            <p data-id="element-68">
              No vendemos, comercializamos ni transferimos tu información
              personal a terceros, excepto a proveedores de servicios de
              confianza que nos ayudan a operar nuestro negocio, siempre que
              estas partes acuerden mantener esta información confidencial.
            </p>
          </section>

          <section data-id="element-69">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-70">
              5. Cookies
            </h3>
            <p data-id="element-71">
              Utilizamos cookies para mejorar tu experiencia en nuestro sitio
              web. Puedes configurar tu navegador para rechazar cookies, aunque
              esto puede afectar algunas funcionalidades del sitio.
            </p>
          </section>

          <section data-id="element-72">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-73">
              6. Tus Derechos
            </h3>
            <p data-id="element-74">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal. También puedes oponerte al procesamiento de tus datos o
              solicitar la portabilidad de los mismos.
            </p>
          </section>

          <section data-id="element-75">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-76">
              7. Cambios a esta Política
            </h3>
            <p data-id="element-77">
              Nos reservamos el derecho de actualizar esta política de
              privacidad en cualquier momento. Te notificaremos sobre cambios
              significativos publicando la nueva política en esta página.
            </p>
          </section>

          <p className="text-slate-500 text-xs mt-8" data-id="element-78">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos de Servicio" data-id="element-79">
        <div className="space-y-6" data-id="element-80">
          <section data-id="element-81">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-82">
              1. Aceptación de los Términos
            </h3>
            <p data-id="element-83">
              Al acceder y utilizar este sitio web y realizar una compra,
              aceptas estar sujeto a estos términos de servicio. Si no estás de
              acuerdo con alguna parte de estos términos, no debes utilizar
              nuestro sitio ni realizar compras.
            </p>
          </section>

          <section data-id="element-84">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-85">
              2. Descripción del Producto
            </h3>
            <p data-id="element-86">
              "Club de las 3AM" es un producto digital en formato PDF que
              contiene información y estrategias para manejar el insomnio
              nocturno. Este producto es únicamente informativo y educativo, y
              no constituye consejo médico profesional.
            </p>
          </section>

          <section data-id="element-87">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-88">
              3. Entrega del Producto
            </h3>
            <p data-id="element-89">
              Una vez completada la compra, recibirás acceso inmediato al
              producto digital. El enlace de descarga se enviará a la dirección
              de correo electrónico proporcionada durante la compra.
            </p>
          </section>

          <section data-id="element-90">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-91">
              4. Política de Reembolso
            </h3>
            <p data-id="element-92">
              Debido a la naturaleza digital del producto, todas las ventas son
              finales. Sin embargo, si experimentas problemas técnicos para
              acceder al producto, trabajaremos contigo para resolver el
              problema.
            </p>
          </section>

          <section data-id="element-93">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-94">
              5. Uso del Producto
            </h3>
            <p data-id="element-95">
              El producto adquirido es para uso personal únicamente. Queda
              prohibida la reproducción, distribución, modificación o reventa
              del contenido sin autorización expresa por escrito.
            </p>
          </section>

          <section data-id="element-96">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-97">
              6. Descargo de Responsabilidad Médica
            </h3>
            <p data-id="element-98">
              El contenido de este producto no pretende ser un sustituto del
              consejo médico profesional, diagnóstico o tratamiento. Siempre
              busca el consejo de tu médico u otro proveedor de salud calificado
              con cualquier pregunta que puedas tener sobre una condición
              médica.
            </p>
          </section>

          <section data-id="element-99">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-100">
              7. Limitación de Responsabilidad
            </h3>
            <p data-id="element-101">
              No seremos responsables de ningún daño directo, indirecto,
              incidental, especial o consecuente que resulte del uso o la
              imposibilidad de usar el producto o los servicios.
            </p>
          </section>

          <section data-id="element-102">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-103">
              8. Propiedad Intelectual
            </h3>
            <p data-id="element-104">
              Todo el contenido incluido en este producto, incluyendo texto,
              gráficos y diseño, es propiedad exclusiva de Club de las 3AM y
              está protegido por las leyes de derechos de autor.
            </p>
          </section>

          <section data-id="element-105">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-106">
              9. Modificaciones
            </h3>
            <p data-id="element-107">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación en el sitio web.
            </p>
          </section>

          <p className="text-slate-500 text-xs mt-8" data-id="element-108">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </Modal>
    </>;
}